export default {
    optionValueProp: "baseAgreementAnnex0Id",
    optionNameProp: "actualAgreementNo",
    optionGroupByProp: "frameAgreementNo",
    filterProp: "actualAgreementNo",
    searchPlaceholder: "Wyszukaj: Numer umowy"
}
